import { currentPage, initNewSection } from '../common/layout';
import { banners, commentsCountUpdate, hitPageView, coralCommentsCountUpdate } from '../common/utils/fn';
import { getM1FindVehicleEu, getM1FindVehicleUs } from '../common/shop/m1-find-vehicle-widget-loader';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';

currentPage.pageInit = ($page, pageData, pageId) => {

  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });
  
  getM1FindVehicleEu().then((api) => {
    api.m1FindVehicleEu();
  });
  getM1FindVehicleUs().then((api) => {
    api.m1FindVehicleUs();
  });
};

currentPage.pageLoadMore = ($html, $btnBox) => {
  //$btnBox.replaceWith($html);
  initNewSection($html);
  // hybridLazyLoad();

  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  commentsCountUpdate(true);
  banners($html);
  hitPageView(document.location.pathname);
  coralCommentsCountUpdate();
};
